// Task 33: Platform detection helper
// Generated by Windsurf Full-Stack Intelligence — Task 33 v33.0 Unified Quick-Action Layer

export const isMobileDevice = () => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || navigator.vendor || window.opera || '';
  const isUA = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(ua);
  const isSmallViewport = typeof window !== 'undefined' ? window.innerWidth < 768 : false;
  return isUA || isSmallViewport;
};

export default isMobileDevice;
